exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-affix{position:fixed;z-index:10}", ""]);

// exports
